import { actionTypes } from 'redux-resource';
import * as api from 'api';

export const sendSprintCallRecords =
  ({ subscription, ...params }) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'voiceRecords',
      requestKey: `sendSprintCallRecords${subscription}`,
      resource: [subscription],
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.CREATE_RESOURCES_PENDING,
    });

    return api
      .sendSprintCallRecords({ ...params, subscription })
      .then((response) => {
        response.id = `sendSprintCallRecords${subscription}`;
        response.success = true;

        dispatch({
          ...actionDefaults,
          type: actionTypes.CREATE_RESOURCES_SUCCEEDED,
          resources: [response],
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.CREATE_RESOURCES_FAILED,
          requestProperties: {
            error: err.response.data,
          },
        });

        return err.response;
      });
  };
